import { atom } from 'jotai';

export type FlavorAtom = 'modal' | 'callout' | 'embedded';

export const flavorAtom = atom<FlavorAtom | undefined>('modal');
